import React, { MutableRefObject } from 'react';

export interface StepContextObject {
  index: number;
  stepRef: MutableRefObject<unknown> | ((instance: unknown) => void) | null;
  isComplete: boolean;
  isCurrent: boolean;
  nextStep(): void;
  previousStep(): void;
  scrollToStep(index: number): void;
  focus(): void;
}

/* eslint-disable no-unused-vars */
export default React.createContext<StepContextObject>({
  index: 0,
  stepRef: null,
  isComplete: false,
  isCurrent: false,
  nextStep: () => {
    /* empty */
  },
  previousStep: () => {
    /* empty */
  },
  scrollToStep: () => {
    /* empty */
  },
  focus: () => {
    /* empty */
  },
});
